module.exports = __webpack_public_path__ + "img/logo-main.cfc1c85b.svg";